import PropTypes from 'prop-types';
import * as React from 'react';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { renderWithRef } from '../core/render-with-ref.js';
import 'tiny-warning';
import { RenderComp } from '../core/render-comp.component.js';
import { useAlertBoxContext } from './alert-box.context.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
const propTypes = {
  visuallyHiddenLabel: PropTypes.node,
  accessibleText: PropTypes.string
};
const propKeysToRemove = Object.keys(propTypes);
const AlertBoxDismissButton = renderWithRef('AlertBoxDismissButton', propTypes, (props, ref) => {
  const classNames = new Set(['swan-alert-box-close-button']);
  const {
    onRequestDismiss
  } = useAlertBoxContext();
  const {
    visuallyHiddenLabel,
    accessibleText,
    children,
    onClick
  } = props;
  const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenLabel;
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: "button",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: _objectSpread({}, props, {
      onClick: composeEventHandlersUtil(onClick, () => typeof onRequestDismiss === 'function' && onRequestDismiss())
    })
  }, accessibleNode !== null ? /*#__PURE__*/React.createElement(VisuallyHidden, null, accessibleNode) : null, children);
});
export { AlertBoxDismissButton };